import { render } from "./NotFoundPage.vue?vue&type=template&id=30d9d43a&scoped=true"
const script = {}

import "./NotFoundPage.vue?vue&type=style&index=0&id=30d9d43a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d9d43a"]])

export default __exports__